<template>
  <ob-client-section type="municipiiClient" label="Header_2">
  </ob-client-section>
</template>

<script>
import ClientSection from '@/components/ClientSection'

export default {
  name: 'municipii-client',
  components: {
    'ob-client-section': ClientSection
  },
  data: () => ({
    type: 'municipiiClient'
  }),
  created () {
    this.$store.dispatch(`${this.type}/setEventWatchers`)
    this.$store.dispatch(`${this.type}/fetchItems`)
  }
}
</script>

<style>

</style>
